import TokenInput from './TokenInput';

export default TokenInput;
